import { useQuery } from '@apollo/client';
import { Select } from 'antd';
import { GET_SHIPPERS } from 'Util/queries';
const { Option } = Select;

function ShippersDropDown({ onChange, form, value, ...rest }) {

    const { data, loading } = useQuery(GET_SHIPPERS, {
        variables: {
            where: {
                deleted_at: { _is_null: true }
            }
        },
    });

    const list = data?.shippers ?? [];

    const handleChange = (v) => {
        const selected = list.find(item => item.id === v);
        if (form && selected) {
            form.setFieldsValue({
                shipper_name: selected.name,
            });
        }
        if (onChange) onChange(v);
    };

    return (
        <Select
            {...rest}
            value={value}
            loading={loading}
            placeholder="Select a shipper"
            onChange={handleChange}
        >
            {list.map(v => <Option value={v.id} key={`shipper-dd-opt${v.id}`}>{v.name}</Option>)}
        </Select>
    )
}

export default ShippersDropDown
